import { SiteContext, SiteContextModel } from "@toolkit/Framework/Components/SiteContext/SiteContext";
import React, { FC, PropsWithChildren, useState } from "react";

export interface SiteContextProviderProps {}

export const SiteContextProvider: FC<PropsWithChildren<SiteContextProviderProps>> = ({ children }) => {
    const [bottomSpacing, setBottomSpacing] = useState<SiteContextModel["bottomSpacing"]>(0);

    return (
        <SiteContext.Provider
            value={{
                bottomSpacing,
                setBottomSpacing,
            }}
        >
            {children}
        </SiteContext.Provider>
    );
};
